var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from "react";
import { CssBaseline, ThemeProvider as MuiThemeProvider, useMediaQuery, } from "@material-ui/core";
import { ThemeContext } from "./ThemeContext";
import { DarkTheme, LightTheme } from "../../theme";
export var ThemeProvider = function (_a) {
    var isDark = _a.isDark, children = _a.children;
    var prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
    var _b = useState(isDark !== null && isDark !== void 0 ? isDark : prefersDarkMode), isDarkMode = _b[0], setIsDarkMode = _b[1];
    var toggleTheme = useCallback(function () {
        setIsDarkMode(!isDarkMode);
    }, [isDarkMode]);
    return (_jsx(ThemeContext.Provider, __assign({ value: {
            isDark: isDark,
            toggleTheme: toggleTheme,
        } }, { children: _jsxs(MuiThemeProvider, __assign({ theme: !!isDark ? DarkTheme : LightTheme }, { children: [_jsx(CssBaseline, {}, void 0), children] }), void 0) }), void 0));
};
